<template>
	<div class="pb-4">
		<template v-if="load_error">
			<div class="row">
				<div class="col-12 mb-4">
					<div class="card border-light" style="width: 18rem; margin: 40px auto 0;">
						<div class="card-body text-center">
							<b-icon icon="exclamation-triangle-fill" variant="danger" font-scale="7.5"></b-icon>
							<h5 class="card-title">{{ $t("not-found") }}</h5>
							<p class="card-text">
								{{ $t('unable-to-open-form') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-else-if="signed_off">
			<div class="row">
				<div class="col-12 mb-4">
					<div class="card border-light" style="width: 18rem; margin: 40px auto 0;">
						<div class="card-body text-center">
							<b-icon icon="check-circle-fill" variant="success" font-scale="7.5" class="mb-2"></b-icon>
							<h5 class="card-title">{{ $t("done") }}</h5>
							<p class="card-text">
								{{ $t('this-form-has-already-been-signed-off') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</template>
        <template v-else-if="withdrawn">
			<div class="row">
				<div class="col-12 mb-4">
					<div class="card border-light" style="width: 18rem; margin: 40px auto 0;">
						<div class="card-body text-center">
							<b-icon icon="exclamation-triangle-fill" variant="warning" font-scale="7.5" class="mb-2"></b-icon>
							<h5 class="card-title">{{ $t("withdrawn") }}</h5>
							<p class="card-text">
								{{ $t('this-form-has-been-withdrawn') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-else-if="done">
			<div class="row">
				<div class="col-12 mb-4">
					<div class="card border-light" style="width: 18rem; margin: 40px auto 0;">
						<div class="card-body text-center">
							<b-icon icon="check-circle-fill" variant="success" font-scale="7.5" class="mb-2"></b-icon>
							<h5 class="card-title">{{ $t('thank-you') }}</h5>
							<p class="card-text">
								{{ $t('form-saved-extuser') }}
							</p>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-else-if="formresponse_data">
			<div class="float-right">
				<template v-if="!isSignedOff">
					<button class="btn btn-success mb-2 ml-2"
						v-if="showSignOffBtn"
						:disabled="!locationReady"
						@click="formresponse.formresponse_signedoff = 1;
						submitFormResponse(); "
					>{{ $t('sign-off') }}</button>
				</template>
			</div>

			<div class="clearfix d-inline-block align-top">
				<h2 class="mb-0">
					<template v-if="formresponse_data.title">
						{{ formresponse_data.title }}
					</template>
					<span v-if="(formresponse.formresponse_abandoned == '1')" class="badge badge-secondary">{{ $t('abandoned') }}</span>
				</h2>
				<p class="mb-4" v-if="submitter.name">
						{{ $t('user-colon') }} <strong>{{ submitter.name }}</strong> 
				</p>
			</div>

			<div class="list-group mb-3" v-if="formresponse.ttevent">
				<div class="list-group-item">
					<strong>{{$t('timetable-event')}}</strong>
				</div>
				<div class="list-group-item">
					<p class="mb-0">
						<template v-if="formresponse.ttevent.ttsessiontype">
							{{formresponse.ttevent.ttsessiontype.name}}
						</template>
						<template v-if="formresponse.ttevent.ttroom">
							- {{formresponse.ttevent.ttroom.name}}
						</template>
					</p>
					<p class="mb-0">
						{{ $datetime.timestampToDate(formresponse.ttevent.date) }}
						{{ $datetime.timestampToTime(formresponse.ttevent.from, false) }}
						- {{ $datetime.timestampToTime(formresponse.ttevent.to, false) }}
					</p>
				</div>
			</div>

			<template v-if="(formresponse_data.navigation == 'sidebar')">
				<TabbedView @done="submitFormResponse" @hasNextChanged="hasNextUpdater">
					<TabbedViewTab v-for="(page, pageIndex) in filteredPages" :title="page.title"
						:id="pageIndex.toString()" :key="pageIndex">
						<FormGrid :page="page" :formresponse="formresponse"
							:readonly="!canEdit || !userCanCompletePage(page)" viewAs="signer"></FormGrid>
					</TabbedViewTab>
				</TabbedView>
			</template>
			<template v-else>
				<template v-for="(page, pageIndex) in filteredPages">
					<div class="card mb-8" :key="pageIndex" v-if="pageNum == pageIndex + 1">
						<div class="card-body">
							<h2 class="card-title" v-if="page.title">{{ page.title }}</h2>
							<FormGrid :page="page" :formresponse="formresponse"
							 :readonly="!canEdit || !userCanCompletePage(page)" viewAs="signer"></FormGrid>
						</div>
					</div>
				</template>
				<div class="clearfix mb-3">
					<button class="btn btn-secondary" v-if="showPreviousPageBtn" @click="previousPage">{{ $t('previous-page') }}</button>
					<button class="btn btn-primary ml-2" v-if="showNextPageBtn" @click="nextPage">{{ $t('next-page') }}</button>
				</div>
			</template>


			<div class="clearfix mb-3">
				<div class="float-right">
					<template v-if="!isSignedOff">
						<button class="btn btn-success mb-2 ml-2"
							v-if="showSignOffBtn"
						 	:disabled="!locationReady"
						  	@click="formresponse.formresponse_signedoff = 1;
                          	submitFormResponse(); "
                        >{{ $t('sign-off') }}</button>
					</template>
				</div>
			</div>
			<GeoLoc @geoloc-done="handleGeoLoc"/>

		</template>

		<div v-if="loading.formresponse">
			<table class="w-100">
				<tr>
					<td><div class="skeleton midnight h32 w-50 rounded mb-1"></div></td>
				</tr>
              <tr v-for="item in Array(7)" v-bind:key="item">
                  <td><div class="skeleton midnight h16 w-100 rounded mb-1"></div></td>
              </tr>
          </table>
		</div>

    </div>
</template>

<script>
import TabbedView from "src/components/TabbedView";
import TabbedViewTab from "src/components/TabbedViewTab";
import FormGrid from "src/components/FormEditor/FormGrid";
import GeoLoc from "src/components/GeoLoc/GeoLoc";

export default {
	components: {
		TabbedView,
		TabbedViewTab,
		FormGrid,
		GeoLoc
	},
    data: function() {
        return {
        	load_error: false,
        	signed_off: false,
            withdrawn:false,
        	done: false,
        	formid: null,
        	formresponse: {
        		id: null,
        		workflowstage_id: null,
				learning_outcomes: [],
        		user_id: null,
				userfrom_id: null,
				usersignofffrom_id: null,
        		externaluser_id: null,
				userreview_id: null,
        		datetime: null,
        		workbooks: [],
        		formresponse_data: null,
        	},
        	locationReady:false,
			locationPermission:'',
            formresponse_data:null,
        	pageNum: 1,
        	signers: [],
			viewAs: [],
			hasNext: false,
			submitter:{
				id: null,
				name:''
			},
			signerData:{
				lat:'',
				long:'',
				browser:'',
				token:''
			},
			loading:{
				formresponse: true,
			},
        }
    },
    methods: {
    	nextPage() {
    		if(this.pageNum < this.filteredPages.length) {
    			this.pageNum++
    		}
    	},
    	previousPage() {
    		if(this.pageNum > 1) {
    			this.pageNum--;
    		}
    	},
    	formSubmitFailed() {
			this.$store.commit("openDialog", {
				title: this.$t("oops"),
				content: this.$t("form-save-failed"),
				confirmCallBack: function() {
				}
			});

    	},
    	formSubmitSuccess() {
    		this.done = true;
			//const self = this;
			/*
			this.$store.commit("openDialog", {
				title: this.$t("saved"),
				content: this.$t("form-saved-extuser"),
			});
			*/

    	},
    	submitFormResponse(silent = false) {
    		this.$store.commit("showBlockingSpinner");

    		if(this.formresponse.datetime){
				this.formresponse.formresponse_dateofresponse = this.$datetime.getTimeStampFromDateTimeField(
					this.formresponse .datetime
				);
			}

  			this.$cfetch(`${this.$settings.APIBaseURL}/externaluser/form/response/save/`, {
  				method: 'post',
  				data: {
  					t: this.signerData.token,
					signerlat: this.signerData.lat,
					signerlong: this.signerData.long,
  					formresponse: this.formresponse,
  				}
  			}).then(res => {
				if(silent) return;
				if (res.status === "SUCCESS") {
                    console.log(res);
					this.formSubmitSuccess();
				} else {
					this.formSubmitFailed();
				}
			}).catch(error => {
				console.error(error)
				this.$log.error.call(this, error);
				this.formSubmitFailed();
			}).finally(() => {
				this.$store.commit("hideBlockingSpinner");
			})
    	},
    	getFormResponse(token) {
    		this.$store.commit("showBlockingSpinner");
  			return this.$cfetch(`${this.$settings.APIBaseURL}/externaluser/login/?t=${token}`)
			.then(res => {
				this.$store.commit("hideBlockingSpinner");
                console.log(res);
				if (res.status === "SUCCESS") {
					if(res.alreadysignedoff){
						this.signed_off = true;
					}
                    if(res.result && res.result.formresponse_completed == 0){
                        this.withdrawn =true;
                    }

					if(res.result){
						this.formresponse = res.result;
						this.formresponse_data= this.formresponse.formresponse_data;
						this.submitter= {
							id: res.result.userfrom_id,
							name: res.result.user_displayname
						};
					}
				} else {
					this.load_error=true;
				}
			}).catch(error => {
				this.$store.commit("hideBlockingSpinner");
				this.load_error=true;
				this.$log.error.call(this, error);
			});
    	},
    	userCanCompletePage(page) {
    		var viewAs = 'signer';
			return !('permission' in page) || page.permission.length === 0 || page.permission.includes(viewAs) || viewAs=='editall'
    	},
    	userCanViewPage(page) {
			return !page.hideifcantcomplete || this.userCanCompletePage(page) || (page.showaftersignoff && this.formresponse && this.formresponse.formresponse_signedoff == '1');
    	},
		hasNextUpdater(data){
			this.hasNext= true;
			this.hasNext= data;
			return data;
		},
		handleGeoLoc(payload){
			
			this.locationPermission = payload.locationPermission;
			this.signerData.lat = payload.coords.lat;
			this.signerData.long = payload.coords.long;
			this.signerData.browser = payload.browser;
			this.loading.geoloc = payload.GeoLocLoading;
            if(payload.coords){
                this.locationReady = true;
            }
		},
    },
    computed: {
    	isSignedOff() {
    		return this.formresponse.formresponse_signedoff == '1';
    	},
    	/*canChangeSignoffFrom() {
    		return this.formresponse.formresponse_signedoff == '0' || this.$UserSession.hasPriv.call(this, "VIEW_ALLFORMS");
    	},*/
    	filteredPages() {
    		const pages = [];
    		if(this.formresponse_data) {
    			for(let page of this.formresponse_data.pages) {
    				if(this.userCanViewPage(page)) {
    					pages.push(page);
    				}
    			}
    		}
    		return pages;
    	},
    	showNextPageBtn() {
    		return this.formresponse_data && this.formresponse_data.next && this.pageNum < this.filteredPages.length;
    	},
    	showPreviousPageBtn() {
    		return this.formresponse_data && this.formresponse_data.previous && this.pageNum > 1;
    	},
		canEdit() {
			return /*this.isTeacher || */!this.isSignedOff;
		},
		showSignOffBtn() {
			return true;
		},
		/*formresponse_id() {
			return this.formresponse ? this.formresponse.formresponse_id : null;
		},
		formresponse_data() {
			return this.formresponse ? this.formresponse.formresponse_data : null;
		},*/
		role(){
			return 'signer';
		}
    },
    mounted() {
    	if(this.$route.params.token !== '') {
    		this.getFormResponse(this.$route.params.token).then(()=>
			{
				this.loading.formresponse= false;
				this.signerData.token = this.$route.params.token;
			})
    	} else {
    		this.load_error = true;
    	}
    }
}
</script>
